import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomAutocompleteComponent } from './custom-autocomplete.component';
import { SharedModule } from '../../shared.module';
import { MaterialModule } from '../../material.module';
import { HighlightPipe } from './high-light.pipe';


@NgModule({
  declarations: [CustomAutocompleteComponent, HighlightPipe],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,],
  exports: [CustomAutocompleteComponent]
})
export class CustomAutocompleteModule { }
